import axiosInstance from "../helper/axiosIntanceApiZalo";
import axios from '../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";

//tien
const view = (params) => {
    return axios.post('/filter/api/loadFieldStaff', normalizeStringInObject(params));
}
const viewByField = (params) => {
    return axios.post('/filter/api/loadOptionStaffByField', normalizeStringInObject(params));
}
const updateFieldStaff = (params) => {
    return axios.post('/filter/api/updateFieldStaff', normalizeStringInObject(params));
}
const viewFieldContact = (params) => {
    return axios.post('/filter/api/loadFieldContact', normalizeStringInObject(params));
}
const viewFieldTicket = (params) => {
    return axios.post('/filter/api/loadFieldTicket', normalizeStringInObject(params));
}
const viewByFieldContact = (params) => {
    return axios.post('/filter/api/loadOptionStaffByField', normalizeStringInObject(params));
}
const updateFieldContact = (params) => {
    return axios.post('/filter/api/updateFieldContact', normalizeStringInObject(params));
}
const updateFieldTicket  = (params) => {
    return axios.post('/filter/api/updateFieldTicket', normalizeStringInObject(params));
}
export default {
    view,
    viewByField,
    updateFieldStaff,
    viewFieldContact,
    viewByFieldContact,
    updateFieldContact,
    updateFieldTicket,
    viewFieldTicket
}
